import { WorkflowWebhookModel } from '@models/workflow-webhook.model';
import { createAction, props } from '@ngrx/store';

export const getWorkflowWebhooks = createAction(
  '[WORKFLOW WEBHOOK] Get WorkflowWebhooks',
  props<{ orgId: string }>(),
);
export const getWorkflowWebhooksServerCall = createAction(
  '[WORKFLOW WEBHOOK] Get WorkflowWebhooks Server Call',
  props<{ orgId: string }>(),
);
export const getWorkflowWebhooksSuccess = createAction(
  '[WORKFLOW WEBHOOK] Get WorkflowWebhooks Success',
  props<{ webhooks: WorkflowWebhookModel.WebhookEndpointMongoDocument[] }>(),
);
export const getWorkflowWebhookshFail = createAction(
  '[WORKFLOW WEBHOOK] Get WorkflowWebhooks Fail',
);

//create
export const createWorkflowWebhook = createAction(
  '[WORKFLOW WEBHOOK] Create WorkflowWebhooks',
  props<{ orgId: string; webhook: WorkflowWebhookModel.CreateWebhookDto }>(),
);
export const createWorkflowWebhookServerCall = createAction(
  '[WORKFLOW WEBHOOK] Create WorkflowWebhooks Server Call',
  props<{ orgId: string; webhook: WorkflowWebhookModel.CreateWebhookDto }>(),
);
export const createWorkflowWebhookSuccess = createAction(
  '[WORKFLOW WEBHOOK] Create WorkflowWebhooks Success',
  props<{ webhook: WorkflowWebhookModel.WebhookEndpointMongoDocument }>(),
);
export const createWorkflowWebhookhFail = createAction(
  '[WORKFLOW WEBHOOK] Create WorkflowWebhooks Fail',
);

//edit
export const editWorkflowWebhook = createAction(
  '[WORKFLOW WEBHOOK] Edit WorkflowWebhooks',
  props<{ id: string; webhook: WorkflowWebhookModel.UpdateWebhookDto }>(),
);
export const editWorkflowWebhookServerCall = createAction(
  '[WORKFLOW WEBHOOK] Edit WorkflowWebhooks Server Call',
  props<{ id: string; webhook: WorkflowWebhookModel.UpdateWebhookDto }>(),
);
export const editWorkflowWebhookSuccess = createAction(
  '[WORKFLOW WEBHOOK] Edit WorkflowWebhooks Success',
  props<{ webhook: WorkflowWebhookModel.WebhookEndpointMongoDocument }>(),
);
export const editWorkflowWebhookhFail = createAction(
  '[WORKFLOW WEBHOOK] Edit WorkflowWebhooks Fail',
);

//delete
export const deleteWorkflowWebhook = createAction(
  '[WORKFLOW WEBHOOK] Delete WorkflowWebhooks',
  props<{ id: string }>(),
);
export const deleteWorkflowWebhookServerCall = createAction(
  '[WORKFLOW WEBHOOK] Delete WorkflowWebhooks Server Call',
  props<{ id: string }>(),
);
export const deleteWorkflowWebhookSuccess = createAction(
  '[WORKFLOW WEBHOOK] Delete WorkflowWebhooks Success',
  props<{ id: string }>(),
);
export const deleteWorkflowWebhookhFail = createAction(
  '[WORKFLOW WEBHOOK] Delete WorkflowWebhooks Fail',
);

export const setIsLoading = createAction(
  '[WORKFLOW WEBHOOK] Set Loading',
  props<{ isLoading: boolean }>(),
);
export const setIsSaving = createAction(
  '[WORKFLOW WEBHOOK] Set Loading',
  props<{ isSaving: boolean }>(),
);
export const resetState = createAction('[WORKFLOW WEBHOOK] Reset State');
export const resetEntities = createAction('[WORKFLOW WEBHOOK] Reset Entities');
